import { clients } from "../../../../utils/siteContent";
import Reveal from "../../../commons/reveal/reveal";
import SectionHeading from "../../../commons/sectionHeading/sectionHeading";
import { StyledClients } from "../../../styled/clients";
import { StyledLayout } from "../../../styled/layout";

const Clients = () => {
  const half = Math.ceil(clients.length / 2);
  const row1 = clients.slice(0, half);
  const row2 = clients.slice(half);

  return (
    <StyledClients.Root id="clientes">
      <StyledLayout.Container>
        <Reveal>
          <SectionHeading
            tag="Clientes"
            title={
              <>
                Nos eligen los líderes de la{" "}
                <StyledLayout.GradientText>medicina laboral</StyledLayout.GradientText>
              </>
            }
            lead="Más de 50 organizaciones —prestadores, empresas y aseguradoras— confían su operación diaria en nuestras soluciones."
          />
        </Reveal>
      </StyledLayout.Container>

      <StyledClients.Marquee>
        <StyledClients.Track className="track">
          {[...row1, ...row1].map((c, i) => (
            <StyledClients.Logo key={`a-${i}`}>
              <img src={c.src} alt={c.alt} loading="lazy" />
            </StyledClients.Logo>
          ))}
        </StyledClients.Track>
        <StyledClients.Track className="track" reverse>
          {[...row2, ...row2].map((c, i) => (
            <StyledClients.Logo key={`b-${i}`}>
              <img src={c.src} alt={c.alt} loading="lazy" />
            </StyledClients.Logo>
          ))}
        </StyledClients.Track>
        <StyledClients.Fade side="left" aria-hidden="true" />
        <StyledClients.Fade side="right" aria-hidden="true" />
      </StyledClients.Marquee>
    </StyledClients.Root>
  );
};

export default Clients;
